import { render, staticRenderFns } from "./ConferenceRoomEdit.vue?vue&type=template&id=908d07c4&scoped=true"
import script from "./ConferenceRoomEdit.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908d07c4",
  null
  
)

export default component.exports